import { City, County, Village } from '@ekt-group/general-purpose-api-interfaces';
import { i18n } from 'i18next';

type AddressDetails = {
  countyId: number;
  cityId: number;
  villageId: number;
  street: string;
  houseNumber: string;
  flatNumber: string;
  fullAddress: string;
};

type InitInAdsMapProps = {
  hideMap: boolean;
  i18n: i18n;
  counties: County[];
  cities: City[];
  villages: Village[];
  onAddressSelected: (details: AddressDetails) => void;
  mapElementId: string;
};

export const initializeInAdsMap = ({
  hideMap,
  i18n,
  counties,
  mapElementId,
  cities,
  villages,
  onAddressSelected,
}: InitInAdsMapProps): void => {
  const inAdsElement = document.getElementById(mapElementId);
  if (!inAdsElement || !window.InAadress) return;

  const parentElement = inAdsElement.parentElement;
  if (!parentElement) return;

  const width = parentElement.offsetWidth;
  const height = width * 0.75;

  inAdsElement.style.width = `${width}px`;
  inAdsElement.style.height = `${height}px`;
  inAdsElement.innerHTML = '';

  try {
    new window.InAadress({
      container: mapElementId,
      mode: hideMap ? 3 : 1,
      ihist: '1993',
      langChange: true,
      defaultBaseLayer: 'ALUSKAART',
      baseLayers: ['ALUSKAART'],
      WMS: [],
      appartment: 1,
      lang: i18n.language,
    });

    const handleAddressSelected = (event: CustomEvent) => {
      const eventDetail = Array.isArray(event.detail) ? event.detail[0] : event.detail;

      const county = counties.find((el) => el.countyEhak === Number(eventDetail.ehakmk));
      const city = cities.find((el) => el.cityEhak === Number(eventDetail.ehakov));
      const village = villages.find((el) => el.villageEhak === Number(eventDetail.ehak));

      onAddressSelected({
        countyId: county?.id ?? 0,
        cityId: city?.id ?? 0,
        villageId: village?.id ?? 0,
        street: eventDetail.liikluspind ?? '',
        houseNumber: eventDetail.aadress_nr ?? '',
        flatNumber: eventDetail.kort_nr ?? '',
        fullAddress: eventDetail.aadress ?? '',
      });
    };

    document.addEventListener('addressSelected', handleAddressSelected as EventListener);
  } catch (error) {
    console.error('Failed to initialize InAadress:', error);
  }
};
